import React from 'react'

const ContextSite = React.createContext({})

export default ContextSite